import { EDomain } from '../base/types';

export enum EPersonalizationErrors {
  workoutsError = 'to_many_workouts_were_disabled',
  domainError = 'no_all_domains_can_be_trained',
}

export enum EImpairment {
  Dyscalculia = 'Dyscalculia',
  ColourBlindness = 'ColourBlindness',
}

export interface ISavePersonalizationDomainStatsPayload {
  domain: EDomain;
  stat: number;
  userId?: number;
}

export interface ISavePersonalizationWorkoutStatsPayload {
  workoutId: number;
  workoutEnabled: boolean;
  disableImpairment?: boolean;
  userId?: number;
}

export interface ISavePersonalizationLEDStatPayload {
  stat: boolean;
  userId?: number;
}
